module.exports = __webpack_public_path__ + "static/quote2-3cc0867d841e8fdd934965dff9be9d86.png";